import logo from '@assets/atg-loading-new-logo-23.gif';

type AtgGifLoaderProps = {
  class?: string;
};

const AtgGifLoader = (props: AtgGifLoaderProps) => {
  return (
    <div class="fixed inset-0 z-[1400] flex items-center justify-center">
      <div class="flex items-center justify-center bg-white">
        <img src={logo} alt="" class={props.class ?? ''} />
      </div>
    </div>
  );
};

export default AtgGifLoader;
